module.exports = __webpack_public_path__ + "media/images/emoticons/think-980d4f0caaaed172a0c7bd83721f2f1e.gif";